import { RegionalUserData } from '@graft/nuget-gc.webportals.regionalusers'

import type { RegionalUser } from '../types/user.type'

type RegionalUserDataConstructor = new (
  userId: string,
  userEmail: string,
  firstname: string,
  lastname: string,
  createdAt?: string,
  createdBy?: string,
  updatedAt?: string,
  updatedBy?: string
) => RegionalUserData

const RegionalUserDataCtor = RegionalUserData as unknown as RegionalUserDataConstructor

const EMPTY_AUDIT_FIELD = ''

export const buildRegionalUserData = ({ id, email, firstname, lastname }: RegionalUser): RegionalUserData =>
  new RegionalUserDataCtor(
    id,
    email,
    firstname,
    lastname,
    EMPTY_AUDIT_FIELD,
    EMPTY_AUDIT_FIELD,
    EMPTY_AUDIT_FIELD,
    EMPTY_AUDIT_FIELD
  )
